import SectionHeading from '@/pages/home/components/SectionHeading';
import { timelineEvents } from '@/mocks/homeData';

const tagColor: Record<string, string> = {
  资金往来: 'bg-accent-500',
  合同文件: 'bg-primary-500',
  内部邮件: 'bg-secondary-500',
  关系图: 'bg-foreground-700',
};

const tagChip: Record<string, string> = {
  资金往来: 'border-accent-200 bg-accent-50 text-accent-700',
  合同文件: 'border-primary-200 bg-primary-50 text-primary-700',
  内部邮件: 'border-secondary-200 bg-secondary-50 text-secondary-700',
  关系图: 'border-background-300 bg-background-100 text-foreground-700',
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="scroll-mt-20 border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          index="05"
          eyebrow="Timeline"
          title="时间脉络"
          desc="从首份合同签署到线索集中曝光，按发生顺序把关键节点排开，事件之间的因果与时间差一眼可见。"
        />

        <ol className="relative ml-1 border-l border-background-300 pl-6 md:ml-2 md:pl-8">
          {timelineEvents.map((event) => (
            <li key={event.id} className="relative pb-7 last:pb-0">
              <span
                className={`absolute top-1.5 h-3 w-3 -translate-x-1/2 rounded-full border-2 border-background-50 ${
                  tagColor[event.tag] ?? 'bg-foreground-500'
                } -left-[24px] md:-left-[32px]`}
              ></span>

              <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                <div className="flex flex-wrap items-center gap-3">
                  <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                    {event.date}
                  </span>
                  <span
                    className={`rounded-full border px-2.5 py-0.5 font-label text-[11px] ${
                      tagChip[event.tag] ?? tagChip['关系图']
                    }`}
                  >
                    {event.tag}
                  </span>
                  <span className="ml-auto flex items-center gap-1 font-label text-[11px] text-foreground-500">
                    <i className="ri-attachment-2 text-sm leading-none"></i>
                    {event.evidence} 项材料
                  </span>
                </div>
                <h3 className="mt-2.5 font-heading text-[15px] font-bold text-foreground-950">
                  {event.title}
                </h3>
                <p className="mt-1.5 text-[13px] leading-6 text-foreground-600">{event.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}